module.exports = __webpack_public_path__ + "static/media/LearnIcon.fe6a8cae.svg";